import React from 'react';

import styles from './TranslationKeyOption.less';

interface TranslationKeyOptionProps {
  /** The `group.key` being offered. */
  translationKey: string;
  /** Its wording for the language on screen, if it has one. */
  text?: string;
}

/**
 * One row in a translation-key picker: the key, with what it currently says beneath.
 *
 * Shared because picking a key by its identifier alone is guesswork — `closing.content`
 * and `closing.content_2` are indistinguishable until you can read them — and because
 * two pickers (the translation field's popover and the rich-text field's Text dropdown)
 * had grown the same markup and the same three LESS rules independently.
 */
const TranslationKeyOption: React.FC<TranslationKeyOptionProps> = ({
  translationKey,
  text,
}) => (
  <span className={styles.optionRow} title={text || translationKey}>
    <span className={styles.optionKey}>{translationKey}</span>
    {text && <span className={styles.optionValue}>{text}</span>}
  </span>
);

/** What a `<Select showSearch>` filters on: the key *and* its wording. */
export function translationSearchText(
  translationKey: string,
  text?: string,
): string {
  return `${translationKey} ${text ?? ''}`.toLowerCase();
}

export default React.memo(TranslationKeyOption);
